// extracted by mini-css-extract-plugin
export default {"tabs":"UploadLayout_tabs__nPSrH","tab":"UploadLayout_tab__2DuvU","tabActive":"UploadLayout_tabActive__Wr67Y"};